import * as types from '../../../../constants/ActionNameConstants';

const initialState = {
  loading: false,
  user: [],
  error: null,
};

const FileRejectReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FILE_REJECT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FILE_REJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    case types.FILE_REJECT_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default FileRejectReducer;
